import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  hours?: number;
  minutes?: number;
  storageKey?: string;
  onExpire?: () => void;
}
export function CountdownTimer({
  hours = 0,
  minutes = 0,
  storageKey = 'nutripeques-countdown-start',
  onExpire
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState<{
    hours: number;
    minutes: number;
    seconds: number;
  } | null>(null);
  const [isExpired, setIsExpired] = useState(false);
  useEffect(() => {
    let startTime = localStorage.getItem(storageKey);
    if (!startTime) {
      startTime = Date.now().toString();
      localStorage.setItem(storageKey, startTime);
    }
    const durationMs = hours * 60 * 60 * 1000 + minutes * 60 * 1000;
    const endTime = parseInt(startTime, 10) + durationMs;
    const calculateTimeLeft = () => {
      const now = Date.now();
      const difference = endTime - now;
      if (difference <= 0) {
        setIsExpired(true);
        onExpire?.();
        return {
          hours: 0,
          minutes: 0,
          seconds: 0
        };
      }
      return {
        hours: Math.floor(difference / (1000 * 60 * 60)),
        minutes: Math.floor(difference / 1000 / 60 % 60),
        seconds: Math.floor(difference / 1000 % 60)
      };
    };
    setTimeLeft(calculateTimeLeft());
    const timer = setInterval(() => {
      const newTimeLeft = calculateTimeLeft();
      setTimeLeft(newTimeLeft);
      if (newTimeLeft.hours === 0 && newTimeLeft.minutes === 0 && newTimeLeft.seconds === 0) {
        clearInterval(timer);
      }
    }, 1000);
    return () => clearInterval(timer);
  }, [hours, minutes, storageKey]);
  if (!timeLeft) return null;
  if (isExpired) {
    return null;
  }
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex justify-center items-center gap-3 my-4" data-id="element-209">
      {timeLeft.hours > 0 && <>
          <div className="flex flex-col items-center" data-id="element-210">
            <div className="bg-[#FF8A65] text-white font-bold text-3xl md:text-4xl w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-xl shadow-inner" data-id="element-211">
              {formatNumber(timeLeft.hours)}
            </div>
            <span className="text-xs font-bold mt-1 text-gray-600 uppercase" data-id="element-212">
              Horas
            </span>
          </div>
          <div className="text-[#FF8A65] font-bold text-3xl md:text-4xl pb-5" data-id="element-213">
            :
          </div>
        </>}
      <div className="flex flex-col items-center" data-id="element-214">
        <div className="bg-[#FF8A65] text-white font-bold text-3xl md:text-4xl w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-xl shadow-inner" data-id="element-215">
          {formatNumber(timeLeft.minutes)}
        </div>
        <span className="text-xs font-bold mt-1 text-gray-600 uppercase" data-id="element-216">
          Minutos
        </span>
      </div>
      <div className="text-[#FF8A65] font-bold text-3xl md:text-4xl pb-5" data-id="element-217">
        :
      </div>
      <div className="flex flex-col items-center" data-id="element-218">
        <div className="bg-[#FF8A65] text-white font-bold text-3xl md:text-4xl w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-xl shadow-inner" data-id="element-219">
          {formatNumber(timeLeft.seconds)}
        </div>
        <span className="text-xs font-bold mt-1 text-gray-600 uppercase" data-id="element-220">
          Segundos
        </span>
      </div>
    </div>;
}